const isBetweenRange = (n, min, max) => min <= n && n <= max;

export default isBetweenRange;
